<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Clock" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g transform="translate(0, 0)" :fill="color" fill-rule="nonzero" id="Shape">
					<path d="M43.5877764,17.6890275 C41.9355405,9.03949662 34.9605034,2.06445935 26.3109725,0.412223561 C10.83817,-2.54325554 -2.54325554,10.83817 0.412223561,26.3109725 C2.06454529,34.9604173 9.03958256,41.9355405 17.6890275,43.5877764 C33.1618298,46.5432556 46.5432556,33.1618298 43.5877764,17.6890275 Z M32.1943446,32.1943446 C31.6572349,32.7314546 30.953664,33.0000095 30.2499977,33.0000095 C29.5463502,33.0000095 28.8427793,32.7314546 28.3056695,32.1943446 L20.0556623,23.9443376 C19.5400369,23.4287122 19.2499977,22.7304693 19.2499977,22 L19.2499977,10.9999905 C19.2499977,9.47992669 20.4813111,8.24998813 22,8.24998813 C23.5186888,8.24998813 24.7499977,9.48001263 24.7499977,10.9999905 L24.7499977,20.8613271 L32.1943446,28.3056695 C33.2685643,29.3798892 33.2685643,31.120125 32.1943446,32.1943446 Z"></path>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>